import React from 'react';
import Alert from 'react-s-alert';
import { DocumentsCard } from './DocumentsCard';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import DocumentSchemaType from '../../model/DocumentSchemaType';
import { DocumentStateListTask } from './document-state-list/DocumentStateListTask';
import PropTypes from 'prop-types';

export class DocumentsCards extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            states: [],
        };
    }

    componentDidMount() {
        this.listDocumentStates();
    }

    render() {
        const { states } = this.state;
        const {
            companyId,
            dashboardState,
            companyManagement,
            saveCardState,
            readCardState,
        } = this.props;

        const commonProps = {
            states,
            companyId,
            dashboardState,
            companyManagement,
        };

        return (
            <React.Fragment>
                <DocumentsCard
                    title={I18nUtils.tr('TR_DOCUMENTOS_EMPRESA')}
                    schemaType={DocumentSchemaType.OUTSOURCE}
                    initialCardState={readCardState('outsourceDocs')}
                    saveCardState={(state) => saveCardState('outsourceDocs', state)}
                    {...commonProps}
                />
                <DocumentsCard
                    title={I18nUtils.tr('TR_DOCUMENTOS_TRABAJADORES')}
                    schemaType={DocumentSchemaType.WORKER}
                    initialCardState={readCardState('workerDocs')}
                    saveCardState={(state) => saveCardState('workerDocs', state)}
                    {...commonProps}
                />
                <DocumentsCard
                    title={I18nUtils.tr('TR_DOCUMENTOS_MAQUINARIA')}
                    schemaType={DocumentSchemaType.MACHINE}
                    initialCardState={readCardState('machineDocs')}
                    saveCardState={(state) => saveCardState('machineDocs', state)}
                    {...commonProps}
                />
                <DocumentsCard
                    title={I18nUtils.tr('TR_DOCUMENTOS_MENSUALES')}
                    schemaType={DocumentSchemaType.MONTHLY}
                    initialCardState={readCardState('monthlyDocs')}
                    saveCardState={(state) => saveCardState('monthlyDocs', state)}
                    {...commonProps}
                />
                <DocumentsCard
                    title={I18nUtils.tr('TR_DOCUMENTOS_MENSUALES_VINCULADOS')}
                    schemaType={DocumentSchemaType.LINKED}
                    initialCardState={readCardState('monthlyLinkedDocs')}
                    saveCardState={(state) => saveCardState('monthlyLinkedDocs', state)}
                    checkMonthly={true}
                    {...commonProps}
                />
                <DocumentsCard
                    title={I18nUtils.tr('TR_DOCUMENTOS_VINCULADOS')}
                    schemaType={DocumentSchemaType.LINKED}
                    initialCardState={readCardState('linkedDocs')}
                    saveCardState={(state) => saveCardState('linkedDocs', state)}
                    {...commonProps}
                />
            </React.Fragment>
        );
    }

    listDocumentStates = () => {
        new DocumentStateListTask()
            .onSuccess((res) => this.setState({ states: res.data }))
            .onFail((error) => Alert.error(error))
            .execute();
    };
}

DocumentsCards.propTypes = {
    companyId: PropTypes.number,
    dashboardState: PropTypes.number,
    companyManagement: PropTypes.string.isRequired,
    saveCardState: PropTypes.func,
    readCardState: PropTypes.func,
};

DocumentsCards.defaultProps = {
    saveCardState: () => null,
    readCardState: () => undefined,
};



// WEBPACK FOOTER //
// ./src/app/shared/document/list/DocumentsCards.jsx